import React, { useEffect, useState } from 'react';
import moment from 'moment';
import Configuraciones from '../../Configuracion/Configuraciones';
import IdleTimeOutModal from './IdleTimeOutModal'
import { useStateValue } from '../../Contexto/store';
import Config from '../../Configuracion/Configuraciones';
import RutasComponente from '../../Configuracion/RutaComponentes';
import { registraAuditoriaCierreSesion } from '../../Utilidades/AuditoriaSesion';
import SetModulos from '../../Configuracion/SetModulos/SetModulos';
import { useIsAuthenticated } from "@azure/msal-react";
import { useMsal } from "@azure/msal-react";
import { withRouter } from 'react-router-dom';
import { LlavesAuthConfig } from '../../Configuracion/Llaves/RepositorioConfig';

export const IdleTimeOutHandler = (props) => {

    //Se extrae del store el usuario para ver si si esta en sesion 
    const [{ sesionUsuario }, dispatch] = useStateValue();

    //determina si el usuario esta autenticado por Azure Active Directory
    const autenticadoADD = useIsAuthenticated();

    // Representa la instalacia de validacion por medio SSO con Azure Active Directory
    const { instance } = useMsal();


    // controla si se presenta o no el modal de salida de sesion
    const [showModal, setShowModal] = useState(false);
    // Controla el tiempo que se va medir de inactividad 
    let timer = undefined;
    // lista de eventos sobre la venta que se van a controlar 
    const events = ['click', 'scroll', 'load', 'keydown'];

    // se encarga de estar monitoreando los eventos que se van a controlar para determinar si el usuario 
    // esta o no activo 
    const eventHandler = (eventType) => {


        // Se guarda en el localstorage la ultima iteraccion del cliente con el sistema
        //basado en la lista de eventos que se se van a monitoriar con el eventhandler que creamos 
        localStorage.setItem('UtmItraSisCli', moment());

        if (timer) {
            IniciaTimer();
        }
    };

    useEffect(() => {
        // Se suscriben los eventos
        addEvents();
        return (() => {
            // se realiza la limpieza del efecto
            removeEvents();
            clearTimeout(timer);
        })
    });


    // realiza la inicializacion del control de tiempo
    const IniciaTimer = () => {

        if (timer) {
            clearTimeout(timer)
        }

        timer = setTimeout(() => {

            let ultimaInteraccionCliente = localStorage.getItem('UtmItraSisCli')
            const diff = moment.duration(moment().diff(moment(ultimaInteraccionCliente)));
            let timeOutInterval = Configuraciones.tiempoSesion;
            // valida si para que se controle el tiempo de sesion ha hecho o no logout el usuario 

            // if(isLogout){
            if (!sesionUsuario.autenticado) {
                clearTimeout(timer)
            }
            else {
                if (diff._milliseconds < timeOutInterval) {
                    IniciaTimer();
                } else {
                    setShowModal(true);
                }
            }

        }, Configuraciones.tiempoSesion);


    }

    // Metodo para realizar la suscripcion de los eventos que se van a controlar
    const addEvents = () => {

        events.forEach(eventName => {
            window.addEventListener(eventName, eventHandler)
        })

        IniciaTimer();
    };

    // limpia la suscripcion de los eventos para el momento en el que se hace el logout
    const removeEvents = () => {
        events.forEach(eventName => {
            window.removeEventListener(eventName, eventHandler)
        })
    };

    // Metodo que se dispara al momento de indicar que se desea seguir navegando
    // Se traslada al componente de IdleTimeModal como una propiedad para que el 
    // Manejo de esta logica se realice desde este componente
    const handleContinueSession = () => {
        setShowModal(false)
        // setLogout(false)
    };


    // Metodo que se dispara al momento de indicar que no se desea seguir navegando
    // Se traslada al componente de IdleTimeModal como una propiedad para que el 
    // Manejo de esta logica se realice desde este componente
    const handleLogout = async (CierreAutomatico) => {
        removeEvents();
        clearTimeout(timer);
        //setLogout(true)
        //onLogout();
        setShowModal(false);

        // Se espera la auditoria ANTES de limpiar la sesion: salirSesion() borra el
        // token y la peticion saldria sin credenciales.
        await registraAuditoriaCierreSesion(sesionUsuario.usuario.userId, CierreAutomatico);

        //se limpiar la variable de sesion del storage la sesion del localstorage
        salirSesion();
    };

    //Funcion para el logout 
    const salirSesion = () => {
        // Limpieza de variable de localstorage del token 
        if (sesionUsuario.autenticado === true && sesionUsuario.tipoLogueo !== 'SSO') {
            LimpiaSesionUsuario();
        }
        else if (sesionUsuario.autenticado === true && sesionUsuario.tipoLogueo === 'SSO' && autenticadoADD === true) {


            instance.logoutRedirect({ postLogoutRedirectUri: LlavesAuthConfig.auth.redirectUri, mainWindowRedirectUri: LlavesAuthConfig.auth.redirectUri })
                .then(response => {
                    LimpiaSesionUsuario();
                })
                .catch(e => {
                    console.log(e);
                });


            

        }
    };


    // Limpia las sesiones de los usuarios 
    const LimpiaSesionUsuario = () => {

        //let etiquetaidiomalocalStorage = "";
        //let rememberlocalStorage = false;
        //let userlocalStorage = "";       

        //try {
        //    etiquetaidiomalocalStorage = localStorage.getItem('etiqueta_idioma');
        //    rememberlocalStorage = localStorage.getItem('remember');
        //    userlocalStorage = localStorage.getItem('User');
        //} catch (err) { }

        //// Se limpiar localstorage
        //localStorage.clear();
        localStorage.removeItem('selected_company');
        localStorage.removeItem('token_seguridad');
        localStorage.removeItem('UtmItraSisCli');

        //if (etiquetaidiomalocalStorage !== null && etiquetaidiomalocalStorage !== undefined && etiquetaidiomalocalStorage !== "")
        //    localStorage.setItem('etiqueta_idioma', etiquetaidiomalocalStorage);

        //if (rememberlocalStorage !== null && rememberlocalStorage !== undefined && rememberlocalStorage !== false && rememberlocalStorage !== "false") {
        //    localStorage.setItem('remember', rememberlocalStorage);
        //    localStorage.setItem('User', userlocalStorage);
        //}

        // se incializa el reducer con la autorizacion del usurio al valor inicial del archivo de rutas donde todo esta denegado 
        dispatch({
            type: "AUTORIZACION",
            autorizacion: {
                Rutas: RutasComponente.Rutas,
                RutaLogin: RutasComponente.RutaLogin,
                RutaHome: RutasComponente.RutaHome,
                RutaNotFound: RutasComponente.RutaNotFound,
                RutaRecorevyPassword: RutasComponente.RutaRecorevyPassword,
                RutaRecorevyPasswordSussed: RutasComponente.RutaRecorevyPasswordSussed,
                RutaChangePassword: RutasComponente.RutaChangePassword,
                Modulo: RutasComponente.Modulo
            }
        });

        // Se inicializa el reducer de modulos del usuario 
        dispatch({
            type: "MODULOS_AUTORIZACION",
            autorizacionMod: {
                Modulos: SetModulos.Modulos
            }
        });

        //se limpia la variable de sesion del storage
        dispatch({
            type: "SALIR_SESION",
            nuevousuario: null,
            autenticado: false,
            tipoLogueo: ''
        });

        //adjunta por medio de las propiedades y de inyectar en su historory la ruta a login 
        props.history.push(Config.rutaPublicacion + RutasComponente.RutaLogin.path);
    };

    return (
        <div>
            <IdleTimeOutModal showModal={showModal}
                handleContinue={handleContinueSession}
                handleLogout={handleLogout}
            />
        </div>
    )

};

export default withRouter(IdleTimeOutHandler);